<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'کیشوتو';
      }
    },
  }
};
</script>

<style lang="scss">

*{
  font-family: "sans";
}

.w-80{
  width: 80%;
}
.v-toast__text{
  direction: rtl;
}
.menu-tab{
  .tabs{
    .nav-tabs{
      justify-content: space-around !important;
      border-bottom: 1px solid #f44336;
    .item-title{

      .tab-title-main{
        background: none !important;
        color: white !important;
        border: none !important;
      }

      .active.tab-title-main{
          border-bottom: 3px solid #f44336 !important;
      }

    }
  }
  }
}

.gallery-tab{
  .swiper-pagination-bullet{
    background: #ffffff !important;
    opacity: 1 !important;
    width: 20px  !important;
    height: 20px  !important;
    margin-left: 6px;
  }

  .swiper-pagination-bullet-active{
    background: #f57f17 !important;
    width: 51px !important;
    border-radius: 20px;
  }
}

.event-calendar-container {
  #persian-calendar #vpc_calendar .vpc_week .vpc_day {
    padding: .5em;
    min-height: 40px;
    display: flex;
    justify-content: center;
    /*text-align: center;*/
  }

  #persian-calendar #vpc_calendar #vpc_days-header {
    background: #42a5d5;
    color: #ffffff;
    justify-content: space-evenly;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
  }


  #persian-calendar #vpc_calendar #vpc_days-header div {
    text-align: center;
    padding: 9px 0px 9px 0px;
    transform: scale(0.8);
    border: none;
    background: #42a5d5;
    color: #ffffff;
  }

  #persian-calendar #vpc_calendar .vpc_week .vpc_day.vpc_week-period-day {
    min-height: 51px;
  }

  #persian-calendar #vpc_calendar #vpc_days-header div:first-child{
    border:none;
  }

  #persian-calendar #vpc_calendar #vpc_days-header div:last-child {
    border:none;
  }
  #persian-calendar #vpc_header #vpc_date-control .vpc_today-btn{
    background-color: #42a5d5 !important;
  }
  #persian-calendar #vpc_header .vpc_period-control .vpc_period-btn{
    background-color: #42a5d5 !important;
  }
  #persian-calendar #vpc_header #vpc_date-control .vpc_control-btn{
    background-color: #42a5d5 !important;
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 5px;
  }
  #persian-calendar #vpc_calendar .vpc_week .vpc_event.oneDay .vpc_event-title{
    display: none;
  }

  #persian-calendar #vpc_calendar .vpc_week.vpc_week-period .vpc_event.oneDay {
    display: flex;
    justify-content: center;
    align-items: center;
  }

}
</style>
